import React, { useId } from 'react';
import styles from '../Input/Input.module.css';

const clsx = (...args) => args.filter(Boolean).join(' ');

const Select = React.forwardRef(function Select(
  {
    label,
    helpText,
    error,
    tone = 'light',
    id,
    options = [],
    children,
    className,
    ...rest
  },
  ref
) {
  const errorId = useId();
  const wrapCls = clsx(
    styles.wrap,
    tone === 'dark' && styles.onDark,
    error && styles.error
  );

  return (
    <div className={wrapCls}>
      {label && (
        <label className={styles.label} htmlFor={id}>
          {label}
        </label>
      )}
      <div className={styles.selectWrap}>
        <select
          ref={ref}
          id={id}
          className={clsx(styles.field, className)}
          aria-invalid={!!error}
          aria-describedby={error ? errorId : undefined}
          {...rest}
        >
          {children ||
            options.map((opt) =>
              typeof opt === 'string' ? (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ) : (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              )
            )}
        </select>
        <span className={styles.chevron}>▼</span>
      </div>
      {(helpText || error) && (
        <span className={styles.helpText} id={error ? errorId : undefined}>
          {error || helpText}
        </span>
      )}
    </div>
  );
});

export default Select;
